import type { PdfFileFragment } from "@src/__generated__/urql-graphql";
import { MediaModel } from "@src/utils/components/dropzone";
import { FieldState } from "formstate";
import { action, computed, makeObservable, observable } from "mobx";

export class FileInputForm {
  @observable.ref existingFile?: MediaModel;
  fileToUpload = new FieldState<File | undefined>(undefined);

  constructor() {
    makeObservable(this);
  }

  @action
  setExistingFile(file: PdfFileFragment) {
    this.existingFile = new MediaModel(file);
  }

  @action
  unsetExistingFile() {
    this.existingFile = undefined;
  }

  serialize() {
    return {
      id: this.existingFile?.id,
      file: this.fileToUpload.value,
    };
  }

  @computed get file() {
    if (this.fileToUpload.value) {
      return new MediaModel(this.fileToUpload.value);
    }

    return this.existingFile;
  }
}
